import * as yup from 'yup';

const initialValues = {
  name: '',
  description: '',
};

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required('KPI name is required')
    .min(2, 'KPI name must be at least 2 characters')
    .max(50, 'KPI name must not exceed 50 characters'),
  description: yup
    .string()
    .test('not-empty', 'KPI description is required', value => {
      // Remove all HTML tags and whitespace
      const plain = value?.replace(/<(.|\n)*?>/g, '').trim();
      return !!plain;
    }),
});

export { initialValues, validationSchema };
